export default __webpack_public_path__ + "media/images/images_v2/bordcell3-cf8ae7c57c57b2af3d0c650940659f3f.png";